import { useEffect, useState } from "react";

import { CryptoSwapsService } from "../services/cryptoSwaps.service";
import type { OtcTiming } from "../types/cryptoSwaps.types";

const OTC_TIMING_TTL_MS = 5 * 60 * 1000;

let cached: { at: number; value: OtcTiming } | null = null;
let inFlight: Promise<OtcTiming | null> | null = null;

function loadOtcTiming(): Promise<OtcTiming | null> {
  if (cached && Date.now() - cached.at < OTC_TIMING_TTL_MS) return Promise.resolve(cached.value);
  inFlight ??= CryptoSwapsService.timing()
    .then((value) => {
      cached = { at: Date.now(), value };
      return value;
    })
    .catch(() => cached?.value ?? null)
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

/**
 * Recent durations of purchases and sales; null until answered, and when the read fails without a previous
 * one.
 */
export function useOtcTiming(): OtcTiming | null {
  const [timing, setTiming] = useState<OtcTiming | null>(() => cached?.value ?? null);
  useEffect(() => {
    let active = true;
    void loadOtcTiming().then((value) => {
      if (active) setTiming(value);
    });
    return () => {
      active = false;
    };
  }, []);
  return timing;
}

export function resetOtcTiming(): void {
  cached = null;
  inFlight = null;
}
